/**
 * errorCode из тел ошибок бэка (opinion-core) , по ним клиент решает , куда вести пользователя
 * antifraud* — App\Exceptions\AntifraudBlockedException::CODE_* , при изменении на бэке обновить и здесь
 */
export enum ApiErrorCode {
  Forbidden = 'forbidden',
  PhoneRequired = 'phoneRequired',
  AntifraudDuplicate = 'antifraudDuplicate',
  AntifraudRestricted = 'antifraudRestricted',
  AntifraudDeviceCheck = 'antifraudDeviceCheck',
}

export const ANTIFRAUD_ERROR_CODES: readonly ApiErrorCode[] = [
  ApiErrorCode.AntifraudDuplicate,
  ApiErrorCode.AntifraudRestricted,
  ApiErrorCode.AntifraudDeviceCheck,
];
